import * as React from 'react';
import classNames from 'classnames';
import './eventDetailsSection.module.scss';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { BrushedLabel } from '../../../atoms/layout/BrushedLabel';

type Props = {
    id: string;
    title: string;
};

@observer
export class EventDetailsSection extends React.Component<Props> {
    render() {
        const { title, id } = this.props;
        return (
            <div styleName={classNames('section-container')}>
                {GlobalStatesV3.viewport.isDesktop && (
                    <div id={id} styleName={classNames('section-header')}>
                        {title}
                    </div>
                )}
                {GlobalStatesV3.viewport.isMobile && <BrushedLabel styleName="section-header">{title}</BrushedLabel>}
                {this.props.children}
            </div>
        );
    }
}
